import { render, staticRenderFns } from "./VFatherProStatistics.vue?vue&type=template&id=026f3149"
import script from "./VFatherProStatistics.vue?vue&type=script&lang=js"
export * from "./VFatherProStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports